import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import { removeStorageRecord } from '../../api/api';
import { apiList } from '../../api/callAPI';
import useUser from '../../hook/useUser';

import { LogoutOutlinedIcon } from '../../constants/images';
import * as basicConstants from '../../constants/basic';
import * as alertConstants from '../../constants/alertMsg';
import * as urlConstants from '../../constants/url';

import theme from '../../theme';

const Logout = (props) => {
  const history = useHistory();
  const { userData, setUserData, setAuthStatusMsg, alertMsg, setAlertMsg } = useUser();
  const { variant, color } = props;

  const handleLogout = () => {
    apiList.apiUserLogout()
      .then(res => {
        removeStorageRecord();
        setAuthStatusMsg(alertConstants.LOGOUT_SUCCESS);
        setUserData(false);
        history.push(urlConstants.PAGE_LOGIN);
      });
  }

  if (variant === 'icon') {
    return (
      <IconButton sx={{ ml: 1 }}>
        <LogoutOutlinedIcon onClick={handleLogout} />
      </IconButton>
    )
  } 

  return (
    <Button
      variant='text-grey-normal'
      onClick={handleLogout}
      sx={{
        '&:hover':{ color: color }
      }}
    >
      <LogoutOutlinedIcon />
      <FormattedMessage id="common.login.logout" />
    </Button>
  )
}

export default Logout;